import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { faGripDotsVertical, faTrash } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
export var LCQuickFilterCard = function LCQuickFilterCard(_ref) {
  var item = _ref.item,
    isSelected = _ref.isSelected,
    onFilterClick = _ref.onFilterClick,
    onDelete = _ref.onDelete;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative group"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onDelete();
    },
    className: "absolute -top-[5px] -right-[5px] opacity-0 group-hover:opacity-100 transition-opacity z-10 bg-white border border-gray-200 rounded-full w-6 h-6 flex items-center justify-center shadow-sm hover:bg-red-50",
    "aria-label": "Delete ".concat(item.name)
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTrash,
    className: "text-black w-[14px] h-[14x]"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: onFilterClick,
    title: item.name,
    className: classNames("relative flex flex-col justify-center rounded-[8px] border pt-[6px] pb-[8px] px-[16px] cursor-pointer w-[150px]", {
      "dark:bg-[#202A35] bg-white border-[#e8e9ea]": !isSelected,
      "bg-[#008280] border-[#008280]": isSelected
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "drag-handle absolute right-2 top-[55%]  opacity-0 group-hover:opacity-100 transition-opacity cursor-grabbing z-10"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faGripDotsVertical,
    className: "text-gray-900 dark:text-gray-400 w-5 h-5"
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames("text-xl font-medium leading-[36px]", {
      "text-[#0c1723] dark:text-white": !isSelected,
      "text-[#f6f7f7]": isSelected
    })
  }, !("count" in item) ? /*#__PURE__*/React.createElement("div", {
    className: "border-solid border-gray-700 border-2 !border-r-transparent animate-spin inline-block w-5 h-5 rounded-full",
    role: "status"
  }) : (item === null || item === void 0 ? void 0 : item.count) || 0), /*#__PURE__*/React.createElement("div", {
    className: classNames("text-[15px] font-normal leading-[22px] truncate w-full", {
      "text-[#008280]": !isSelected,
      "text-white": isSelected
    })
  }, item.name)));
};